/* eslint-disable react-hooks/exhaustive-deps */
import './Bookmark.css';
import { useState, useEffect, useRef, forwardRef } from 'react';
import _ from 'lodash';
import I18n from '@/rI18n';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';

import TagDefaultBookmark from './TagDefaultBookmark';
import BookmarkPopup from './BookmarkPopup';
import BookmarkDialogConfirm from './BookmarkDialogConfirm';
import DataChangePleaseReloadModal from '../../../common/modal/DataChangePleaseReloadModal';

import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';

import {getAllBookmarkInProjectInuse, handleSubmitEditBookmark} from '../../handler/BookmarkHandler';
import { multiPanelAtom, panelStartIndexAtom } from '@/state/atom/panelAtom';
import { triggerReLoadKnowledgeTicketDetailAtom } from '@/state/atom/ticketKnowledgeAtom';
import { triggerReLoadHelpdeskTicketDetailAtom } from '@/state/atom/ticketAtom';
import { triggerReloadTicketListByPanelType } from '@/state/selector/panelSelector';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';

function Bookmark({
    isTicketBookmark = false,
    isViewDelete = false,
    ticketKnowledge,
    panelType = Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
    isShowEdit = false,
    isShowDefaultBookmark = false,
    tagDefaultBookmarkClassName = '',
    bookmarkPopupContainerClassName = '',
}) {
    const bookmarkTargetType = Utils.getBookmarkTargetTypeByTicketType(ticketKnowledge?.ticketType);
    const [currentIndex, setCurrentIndex] = useRecoilState(panelStartIndexAtom);
    const userDetail = useRecoilValue(userAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const corporationDetail = useRecoilValue(corporationAtom);

    const panelList = useRecoilValue(multiPanelAtom);
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);

    const setTriggerReLoadKnowledgeTicketDetail = useSetRecoilState(triggerReLoadKnowledgeTicketDetailAtom);
    const setTriggerReLoadHelpdeskTicketDetail = useSetRecoilState(triggerReLoadHelpdeskTicketDetailAtom);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);

    const [mobilePopupMarginLeft, setMobilePopupMarginLeft] = useState(0)
    const [isLoadingBookmark, setIsLoadingBookmark] = useState(false)
    const [isDisplayBookmarkPopup, setIsDisplayBookmarkPopup] = useState(false)
    const [isDisplayBookmarkList, setIsDisplayBookmarkList] = useState(false)

    const [isShowDialogConfirmSubmitData, setIsShowDialogConfirmSubmitData] = useState(false);
    const [isShowDialogConfirmCancelData, setIsShowDialogConfirmCancelData] = useState(false);
    const [isShowDialogConfirmDuplicateShareBookmark, setIsShowDialogConfirmDuplicateShareBookmark] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState({
        isOpen: false,
        errorCode: ''
    });

    const [editNameError, setEditNameError] = useState('')

    const [taggedBookmarkList, setTaggedBookmarkList] = useState([])
    const [listBookmark, setListBookmark] = useState([]);
    const [listBookmarkCompare, setListBookmarkCompare] = useState([]); // only set when first init

    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [onChangeSubmitData, setOnChangeSubmitData] = useState({
        addNew: [],
        edit: []
    })

    const downIconRef = useRef(null);
    const bookmarkPopupRef = useRef(null);

    const handleOpenBookmarkPopup = async() => {
        if (isViewDelete) return;
        if (isDisplayBookmarkPopup) return;

        setTimeout(() => {
            setIsDisplayBookmarkPopup(true);

            setIsLoadingBookmark(true);

            getAllBookmarkInProjectInuse(userDetail.id, projectInuseDetail.id, bookmarkTargetType)
                .then(initBookmarkList => {
                    if (!Utils.isEmptyArray(initBookmarkList)) {
                        const mySystemBookmark = initBookmarkList.find(b => b.definition === Constant.BOOKMARK_DEFINITION.SYSTEM && b.creator === userDetail.id)

                        initBookmarkList = initBookmarkList.map(b => ({
                            ...b,
                            name: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, b.name),
                            defaultBookmark: b.id === mySystemBookmark.defaultBookmark
                                ? b.id
                                : b.defaultBookmark === Constant.NA
                                    ? ''
                                    : b.defaultBookmark
                        }));

                        let taggedList = [...ticketKnowledge?.privateBookmarkData, ...ticketKnowledge?.shareBookmarkData].map(b => {
                            for (let initBookmark of initBookmarkList) {
                                if (b.bookmarkId === initBookmark.id) {
                                    return {...initBookmark}
                                }
                            }
                            return null
                        })
                        if (taggedList.some(tagged => !tagged)) {
                            setIsOpenModalReloadPage({isOpen: true})
                        }

                        taggedList = taggedList.filter(tagged => !!tagged)
                        taggedList = Utils.sortListBookmarkByNameASC(taggedList) // only sort when get init
                        setTaggedBookmarkList(taggedList)

                        const initListBookmark = [...initBookmarkList].map(b => {
                            if (taggedList.map(t => t.id).includes(b.id)) {
                                return {...b, isTagged: true, isDeleted: false}
                            }
                            return {...b, isTagged: false, isDeleted: false}
                        })

                        setListBookmarkCompare([...initListBookmark])
                        setListBookmark([...initListBookmark])
                        setOnChangeSubmitData({
                            addNew: [],
                            edit: [...initListBookmark]
                        })

                        
                        setFilteredSuggestions([]);
                    }
                })
                .catch(err => {
                    console.log('getAllBookmarkInProjectInuse err >>>', err)
                })
                .finally(() => {
                    setIsLoadingBookmark(false)
                })
        }, 0)
    }

    const handleCloseBookmarkPopup = (listCompare, submitData, isFocusOut = false, editError, callBackToPanel) => {
        let isChangedSubmitData = false;
        if (!Utils.isEmptyString(editError)) {
            isChangedSubmitData = true
        }

        if (!Utils.isEmptyArray(submitData?.addNew)) {
            isChangedSubmitData = true
        }

        let editData= [...submitData.edit]
        for (let i = 0; i < listCompare.length; i++) {
            const initEditData = listCompare[i]
            for (let y = 0; y < editData.length; y++) {
                const edited = editData[y];
    
                if (initEditData.id === edited.id && !_.isEqual(initEditData, edited)) {
                    isChangedSubmitData = true;
                    break;
                }
            }
        }
        
        if (isChangedSubmitData) {
            if (isFocusOut) {
                if (!Utils.isEmptyString(editError)) {
                    if (callBackToPanel) {
                        callBackToPanel()
                    }
                    setIsShowDialogConfirmCancelData(true)
                    return
                }
                if (callBackToPanel) {
                    callBackToPanel()
                }
                setIsShowDialogConfirmSubmitData(true)
                return
            }
            if (callBackToPanel) {
                callBackToPanel()
            }
            setIsShowDialogConfirmCancelData(true)

        } else {
            setIsDisplayBookmarkPopup(false)
            setIsDisplayBookmarkList(false)
            setMobilePopupMarginLeft(0)
        }
    }

    const submitEditBookmark = async () => {
        setIsShowDialogConfirmSubmitData(false);

        const funcTriggerDetailTicket = bookmarkTargetType === Constant.BOOKMARK_TARGET_TYPE.KNOWLEDGE
            ? setTriggerReLoadKnowledgeTicketDetail
            : setTriggerReLoadHelpdeskTicketDetail
            
        await handleSubmitEditBookmark(
            onChangeSubmitData,
            listBookmarkCompare,
            corporationDetail,
            projectInuseDetail,
            userDetail,
            ticketKnowledge,
            setIsLoadingBookmark,
            setIsOpenModalReloadPage,
            funcTriggerDetailTicket,
            reloadTicketListByPanelType
        );

        setIsDisplayBookmarkPopup(false)
        setIsDisplayBookmarkList(false)
        setMobilePopupMarginLeft(0)
    }

    // handle event mouseClick is blur bookmarkPopup
    useEffect(() => {
        const handleClickOutside = (event) => {
            let mouseIsOutFocus = true;

            if (downIconRef.current.contains(event.target)) {
                mouseIsOutFocus = false
            }
            if (bookmarkPopupRef.current.contains(event.target)) {
                mouseIsOutFocus = false
            }

            if (
                isShowDialogConfirmSubmitData ||
                isShowDialogConfirmCancelData ||
                isShowDialogConfirmDuplicateShareBookmark
            ) {
                mouseIsOutFocus = false
            }

            if (mouseIsOutFocus && !isLoadingBookmark) {
                handleCloseBookmarkPopup(listBookmarkCompare, onChangeSubmitData, mouseIsOutFocus, editNameError)
            }
        };

        if (isDisplayBookmarkPopup) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        isDisplayBookmarkPopup,
        isDisplayBookmarkList,
        listBookmarkCompare,
        onChangeSubmitData,
        isShowDialogConfirmSubmitData,
        isShowDialogConfirmCancelData,
        isShowDialogConfirmDuplicateShareBookmark,
        editNameError,
        isLoadingBookmark
    ]);

    // handle event touch next/back panel on mobile
    useEffect(() => {
        const windowWidth = window.innerWidth
        if (windowWidth < Constant.PANEL_RESPONSIVE.MOBILE) {
            const isFocusingKnowledgeOrTicketPanel = panelList[currentIndex]?.type === panelType
            if (!isFocusingKnowledgeOrTicketPanel && isDisplayBookmarkPopup) {
                handleCloseBookmarkPopup(
                    listBookmarkCompare,
                    onChangeSubmitData,
                    true,
                    editNameError,
                    () => {
                        setCurrentIndex(panelList.findIndex(p => p.type === panelType))
                    }
                )
            }
        }
    }, [
        panelList,
        currentIndex,
        isDisplayBookmarkPopup,
        isDisplayBookmarkList,
        listBookmarkCompare,
        onChangeSubmitData,
        isShowDialogConfirmSubmitData,
        isShowDialogConfirmCancelData,
        isShowDialogConfirmDuplicateShareBookmark,
        editNameError
    ])

    // handle calculate bookmarkPopup position on mobile
    useEffect(() => {
        const windowWidth = window.innerWidth
        if (isDisplayBookmarkPopup && windowWidth < Constant.PANEL_RESPONSIVE.MOBILE) {
            if (currentIndex === 0) {
                setMobilePopupMarginLeft(0)
                return;
            }

            const panelOuterElement = document.querySelector('.panel-outer')
            const panelWidth = panelOuterElement.offsetWidth;
            const marginLeft = panelWidth * currentIndex;

            setMobilePopupMarginLeft(marginLeft)
            return;
        } else {
            setMobilePopupMarginLeft(0)
        }
    }, [panelList, currentIndex, isDisplayBookmarkPopup,])

    return (
        <>
            <div className={`bookmark-container`}>
                {(!isTicketBookmark && isShowDefaultBookmark) && (
                    <TagDefaultBookmark
                        isViewDelete={isViewDelete}
                        ticketKnowledge={ticketKnowledge}
                        setTriggerReloadKnowledgeListPanel={reloadTicketListByPanelType}
                        corporationDetail={corporationDetail}
                        projectInuseDetail={projectInuseDetail}
                        userDetail={userDetail}
                        className={tagDefaultBookmarkClassName}
                        bookmarkTargetType={bookmarkTargetType}
                    />
                )}
                <div className="bookmark-detail">
                    {isShowEdit && (
                        <EditIcon
                            ref={downIconRef}
                            className={`bookmark-down-icon ${isViewDelete ? 'bookmark-down-icon-disable' : ''}`}
                            onClick={() => handleOpenBookmarkPopup()}
                        />
                    )}
                    {isDisplayBookmarkPopup && (
                        <BookmarkPopup
                            ref={bookmarkPopupRef}
                            bookmarkPopupContainerClassName={bookmarkPopupContainerClassName}
                            ticketKnowledge={ticketKnowledge}
                            handleCloseBookmarkPopup={handleCloseBookmarkPopup}
                            isDisplayBookmarkList={isDisplayBookmarkList}
                            setIsDisplayBookmarkList={setIsDisplayBookmarkList}

                            taggedBookmarkList={taggedBookmarkList}
                            setTaggedBookmarkList={setTaggedBookmarkList}
                            listBookmarkCompare={listBookmarkCompare}
                            listBookmark={listBookmark}
                            setListBookmark={setListBookmark}
                            filteredSuggestions={filteredSuggestions}
                            setFilteredSuggestions={setFilteredSuggestions}
                            
                            onChangeSubmitData={onChangeSubmitData}
                            setOnChangeSubmitData={setOnChangeSubmitData}

                            editNameError={editNameError}
                            setEditNameError={setEditNameError}

                            setIsShowDialogConfirmDuplicateShareBookmark={setIsShowDialogConfirmDuplicateShareBookmark}

                            userDetail={userDetail}
                            projectInuseDetail={projectInuseDetail}
                            isProjectManager={isProjectManager}

                            mobilePopupMarginLeft={mobilePopupMarginLeft}
                            
                            isLoadingBookmark={isLoadingBookmark}
                            handleSubmitEditBookmark={submitEditBookmark}

                            isShowDialogConfirmSubmitData={isShowDialogConfirmSubmitData}
                        />
                    )}
                </div>
            </div>

            {/* Submit Dialog Confirm */}
            <BookmarkDialogConfirm
                className='bookmark-dialog-confirm'
                isOpen={isShowDialogConfirmSubmitData}
                msgConfirm={I18n.get('DO_YOU_WANT_TO_SAVE_BOOKMARK_SETTING')}
                saveAndCancelCallBack={submitEditBookmark}
                closeCallBack={() => {
                    setIsShowDialogConfirmSubmitData(false)
                    setIsDisplayBookmarkPopup(false)
                    setIsDisplayBookmarkList(false)
                    setMobilePopupMarginLeft(0)
                }}
                cancelCallBack={() => {
                    setIsShowDialogConfirmSubmitData(false)
                }}
            />
            {/* Cancel Dialog Confirm*/}
            <BookmarkDialogConfirm
                className='bookmark-dialog-confirm'
                isOpen={isShowDialogConfirmCancelData}
                msgConfirm={I18n.get('DO_YOU_WANT_TO_CANCEL_BOOKMARK_SETTING')}
                saveAndCancelCallBack={() => {
                    setIsShowDialogConfirmCancelData(false)
                    setIsDisplayBookmarkPopup(false)
                    setIsDisplayBookmarkList(false)
                    setMobilePopupMarginLeft(0)
                    setEditNameError('')
                }}
                closeCallBack={() => {
                    setIsShowDialogConfirmCancelData(false)
                }}
            />
            {/* Confirm Duplicate Share Bookmark */}
            <BookmarkDialogConfirm
                className='bookmark-dialog-confirm'
                isOpen={isShowDialogConfirmDuplicateShareBookmark}
                msgConfirm={I18n.get('MSG_BOOKMARK_SAME_NAME_SHARED_BOOKMARK')}
                saveAndCancelCallBack={() => {
                    setIsShowDialogConfirmDuplicateShareBookmark(false)
                    setEditNameError('')
                }}
            />
            {/* Reload Confirm Dialog */}
            <DataChangePleaseReloadModal
                isOpen={isOpenModalReloadPage.isOpen}
                setClose={() => setIsOpenModalReloadPage({isOpen: false, errorCode: ''})}
                content={I18n.get(isOpenModalReloadPage.errorCode)}
            />
        </>
    );
}

export default Bookmark;

const EditIcon = forwardRef(({className, onClick}, ref) => {
    return (
        <svg ref={ref} className={className} onClick={onClick} width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M12.6666 2.11442C12.5066 2.11442 12.3481 2.14594 12.2002 2.2072C12.0523 2.26846 11.9179 2.35825 11.8047 2.47144L2.9299 11.3463L2.28345 13.7166L4.65376 13.0701L13.5286 4.1953C13.6418 4.08211 13.7315 3.94773 13.7928 3.79984C13.8541 3.65195 13.8856 3.49344 13.8856 3.33337C13.8856 3.17329 13.8541 3.01478 13.7928 2.86689C13.7315 2.71901 13.6418 2.58463 13.5286 2.47144C13.4154 2.35825 13.281 2.26846 13.1331 2.2072C12.9852 2.14594 12.8267 2.11442 12.6666 2.11442ZM11.6899 0.975363C11.9996 0.847099 12.3315 0.781082 12.6666 0.781082C13.0018 0.781082 13.3337 0.847099 13.6434 0.975363C13.953 1.10363 14.2344 1.29163 14.4714 1.52863C14.7084 1.76563 14.8964 2.04699 15.0246 2.35665C15.1529 2.66631 15.2189 2.9982 15.2189 3.33337C15.2189 3.66854 15.1529 4.00042 15.0246 4.31008C14.8964 4.61974 14.7084 4.9011 14.4714 5.1381L5.47138 14.1381C5.38934 14.2201 5.28732 14.2793 5.17539 14.3099L1.50872 15.3099C1.27791 15.3728 1.03107 15.3073 0.861904 15.1381C0.692737 14.9689 0.627185 14.7221 0.690132 14.4913L1.69013 10.8246C1.72066 10.7127 1.77987 10.6107 1.8619 10.5286L10.8619 1.52863C11.0989 1.29163 11.3803 1.10363 11.6899 0.975363Z" fill="#9096A2"/>
        </svg>
    )
});
